import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { Button } from "components/core/Button";

import "./PSPModuleWrapper.scss";

export default function PSPModuleWrapper({
	children,
	className,
	linkUrl,
	linkText,
	scrollRef,
	onScroll
}) {
	return (
		<div
			ref={scrollRef}
			onScroll={onScroll}
			className={classnames("psp-module", className)}
		>
			{children}
			{!!linkUrl && <Button href={linkUrl}>{linkText}</Button>}
		</div>
	);
}

PSPModuleWrapper.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	linkUrl: PropTypes.string,
	linkText: PropTypes.string,
	scrollRef: PropTypes.object,
	onScroll: PropTypes.func
};
